export const formattedDateUS = (date, options) => date.toLocaleDateString('en-US', options).replace(/\//g, '-');
